import React, { useState } from 'react'
import GalleryFrame from '../gallery-frame/GalleryFrame'

import Styles from "../CommonGallery.module.scss"

import { TravelPhotos } from '../..//data/travel';
import { Categories } from '../../constants/categories';

interface TravelProps {
    theme: string;
    category: string
    isEditing:boolean;
    onEditClick:()=>void;
}

const Travel = ({theme,category,isEditing,onEditClick }: TravelProps) => {

    const [image, setImage] = useState(`../images/placeholders/${category}.gif`)
    const [page,setPage]=useState(1)
    const [imageIndex,setImageIndex]=useState(0)
    const pageLimit=Categories.TRAVEL.perPageLimit;

    const handleImageClick = (url: string,index:number) => {
        setImageIndex(index)
        setImage(url)
    }

    const handlePageClick=(pageNumber:number)=>{
        setPage(pageNumber)
    }

    const getPhotos = () => {
        return (<div className={Styles.gallery}>

            {TravelPhotos.slice(((page-1)*pageLimit),page*pageLimit).map((photo,index:number) => {
                return (
                    <div className={Styles.image} onClick={() => { handleImageClick(photo.imgUrl,index) }}>
                        <img src={photo.imgUrl} loading={"lazy"} />
                    </div>
                )
            })}

        </div>
        )
    }

    return (
        <div>
            <GalleryFrame
                mainImage={image}
                category={category}
                theme={theme}
                photosGallery={getPhotos()} 
                numberOfPages={TravelPhotos.length/pageLimit}
                currentPage={page}
                pageClick={handlePageClick}
                isEditing={isEditing}
                onEditClick={onEditClick}
                />
        </div>
    )

}

export default Travel
